/**
 * merge.js
 *
 * @Author: apple
 * @Date: 2018/1/5 10:15
 */

import deepExtend from 'deep-extend';
import { hasChildren, isObject } from './isType';

const merge = originalData => {
    const typeObject = isObject(originalData);
    const typeArray = Array.isArray(originalData);
    let copyObj;
    if (hasChildren(originalData)) {
        if (typeArray) {
            copyObj = [];
            originalData.forEach((item, index) => {
                copyObj[index] = {};
                deepExtend(copyObj[index], item);
            });
        }
        if (typeObject) {
            copyObj = {};
            deepExtend(copyObj, originalData);
        }
    } else {
        copyObj = originalData;
    }
    return copyObj;
};

export default merge;



// WEBPACK FOOTER //
// ./src/util/merge.js